const carpayPayLaterRoute = '/carpay/orders/pay-later'

export default carpayPayLaterRoute
